// This file is GENERATED by the CMS server. Do NOT edit directly.

const GENERATED_HERO_SLIDES_DATA = {
  stripImages: [
  "/images/hero-strip/img_1782496709819_2y82q.webp",
  "/images/hero-strip/img_1782499387220_3l2zb.webp",
  "/images/hero-strip/img_1785598539946_z4coe.webp",
  "/images/hero-strip/img_1785598559494_fe40v.webp",
  "/images/hero-strip/img_1785598583115_4s7gu.webp",
  "/images/hero-strip/img_1785598591157_x0vv9.webp"
],
  slideImages: [
  "/images/hero-slides/img_1782500597778_p8nov.webp",
  "/images/hero-slides/img_1785598469941_yl2vz.webp",
  "/images/hero-slides/img_1785598481452_6pyuc.webp",
  "/images/hero-slides/img_1785598508226_lbo81.webp",
  "/images/hero-slides/img_1785598533240_7e12e.webp",
  "/images/hero-slides/img_1785598569172_zvvc8.webp"
],
};

export default GENERATED_HERO_SLIDES_DATA;
